/* unplugin-vue-components disabled */import { render } from "./FAQDialog.vue?vue&type=template&id=e2367c94&scoped=true"
import script from "./FAQDialog.vue?vue&type=script&lang=js"
export * from "./FAQDialog.vue?vue&type=script&lang=js"

import "./FAQDialog.vue?vue&type=style&index=0&id=e2367c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2367c94"]])

export default __exports__